// apps/admin/src/features/customers/components/CustomerDetailPage.tsx
import CustomerDetail from './CustomerDetail';

/**
 * CustomerDetailPage - Page wrapper for the Customer detail view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Properties, Invoices)
 * are provided at the route level in App.tsx
 */
export default function CustomerDetailPage() {
  return <CustomerDetail />;
}
